import { Banner, Button, InlineGrid, InlineStack, Link, Modal, Select, Text, Tooltip, BlockStack } from '@shopify/polaris'
import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core'
import { add_template, delete_template, change_template } from '../../../../Asests/svgIcon/icon';
import { openModalI } from '../Utilities/Interface';
import { GridApis } from '../Utilities/Apis';
import { appBridgeRouting } from '../../Panel/index';
import { getShopID, newFormattedStatus } from '../Utilities/Helper';
import { useTranslation } from 'react-i18next';

interface props extends DIProps {
    row: any
    activityRefreshAction: () => void
    selectOpt: any
    t: any
}

const GetTemplate = (props: props) => {
    let { row, t, activityRefreshAction, selectOpt } = props;

    let renderTemplate: JSX.Element = <></>;
    const [showInfoBanner, setShowInfoBanner] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectTemplateOpt, setSelectTemplateOpt] = useState<string>('');
    const [openModal, setOpenModal] = useState<openModalI>({ open: false, modalHead: "" });
    const [initialVal, setInitialVal] = useState<string>('');

    const handleSelectChange = useCallback((value: string) => {
        value === initialVal ? setShowInfoBanner(false) : setShowInfoBanner(true);
        setSelectTemplateOpt(value)
    }, [initialVal]);

    useEffect(() => {
        if (openModal?.open) {
            if (row?.profile && Object.values(row?.profile)?.length > 0) {
                if (row?.profile?.type !== 'query') {
                    setSelectTemplateOpt(row?.profile?.profile_id?.['$oid'])
                    setInitialVal(row?.profile?.profile_id?.['$oid'])
                };
            }
        }
    }, [openModal.open])

    const DataToSend = (type: string) => {
        let data: any = {};
        if (type === "save" || type == 'change') {
            data = {
                "data": {
                    "_id": selectTemplateOpt,
                    "type": "profile",
                    "manual_product_ids": [row?.['container_id']]
                }
            }
        }
        else {
            data = {
                "data": {
                    "_id": row?.profile?.['profile_id']?.['$oid'],
                    "type": "profile",
                    "manual_product_ids": [row?.['container_id']]
                }
                , "delete": true
            }
        }

        return data;
    }

    const actionOnTemplate = (type: string) => {
        setLoading(true)
        props.di.POST(GridApis.savePartialChunk, DataToSend(type))
            .then((res: any) => {
                if (res?.success) {
                    if (type === 'save')
                        props.success(t('Template added to the product.'))
                    else if (type === 'change')
                        props.success(t('Product assigned to the selected template.'))
                    else if (type = 'delete')
                        props.success(t('Template removed from the product.'))

                    setLoading(false)
                    activityRefreshAction()
                }
                else props.error(t(res?.message))
            })
            .catch((error) => {
                props.error(t(error));
                console.error(error);
            });
        setTimeout(() => {
            setOpenModal({ open: false, modalHead: "" })
            setSelectTemplateOpt("")
        }, 800)
    }

    // const isActiveProduct = () => {
    //     let disableTemplateUpdate: boolean = false;
    //     let res = newFormattedStatus(row, getShopID(props));
    //     if (res && res?.label != 'Not Listed' && res?.label != "Ready To Upload" && res?.label != 'Not Listed: Offer') disableTemplateUpdate = true
    //     return disableTemplateUpdate
    // }

    if (row?.profile) {
        if (Object.values(row?.profile)?.length > 0) {
            if (row?.profile?.type == 'query') {
                renderTemplate = (
                    <Tooltip dismissOnMouseOut content={row?.profile?.['profile_name']}>
                        <Link onClick={() => {
                            appBridgeRouting(`config/template/${row?.profile?.profile_id?.['$oid']}`, { ...props, fromListingGrid: true })
                            // props.history(`../config/template/${row?.profile?.profile_id?.['$oid']}`, { replace: false, state: { fromListingGrid: true } })
                        }}>
                            {
                                row?.profile?.['profile_name']?.length > 15 ? row?.profile?.['profile_name']?.substr(0, 15) + '...' : row?.profile?.['profile_name']
                            }
                        </Link>
                    </Tooltip>)
            }
            else {
                renderTemplate = (
                    <InlineStack wrap={false} align='start' gap="0">
                        <div className='Custom__Button--Add'>
                            <Tooltip dismissOnMouseOut content={row?.profile?.['profile_name']}>
                                <Link onClick={() => {
                                    appBridgeRouting(`config/template/${row?.profile?.profile_id?.['$oid']}`, props)
                                }}>
                                    {
                                        row?.profile?.['profile_name']?.length > 15 ?
                                            row?.profile?.['profile_name']?.substr(0, 15) + '...'
                                            : row?.profile?.['profile_name']
                                    }
                                </Link>
                            </Tooltip>
                        </div>
                        <InlineStack blockAlign='center' gap="100" align='start'>
                            <Tooltip dismissOnMouseOut content={t('Change Template')}>
                                <Button
                                    icon={change_template}
                                    onClick={() => setOpenModal({ open: true, modalHead: "Change Template" })}
                                    variant="monochromePlain"
                                />
                            </Tooltip>
                            <Tooltip dismissOnMouseOut content={t('Remove Template')}>
                                <Button
                                    icon={delete_template}
                                    onClick={() => setOpenModal({ open: true, modalHead: "Remove Template" })}
                                    variant="monochromePlain"
                                />
                            </Tooltip>
                        </InlineStack>
                    </InlineStack >
                )
            }
        }
        else if (selectOpt?.options?.length > 0) {
            renderTemplate = (
                <InlineStack gap="200">
                    <Text as='span'>{t("N/A")}</Text>
                    <Tooltip dismissOnMouseOut content={t('Add Template')}>
                        <Button
                            icon={add_template}
                            onClick={() => setOpenModal({ open: true, modalHead: "Add Template" })}
                            variant="monochromePlain" />
                    </Tooltip>
                    {/* } */}
                </InlineStack>
            )
        }
        else renderTemplate = <>{t("N/A")}</>
    }
    else if (selectOpt?.options?.length > 0) {
        renderTemplate = (
            <InlineGrid gap="200" columns='2'>
                <Text as='p'>{t("N/A")}</Text>
                <Tooltip dismissOnMouseOut content={t('Add Template')}>
                    <Button
                        icon={add_template}
                        onClick={() => setOpenModal({ open: true, modalHead: "Add Template" })}
                        variant="monochromePlain"
                    />
                </Tooltip>
                {/* } */}
            </InlineGrid>
        )
    }
    else renderTemplate = <>{t("N/A")}</>

    return <React.Fragment>
        {renderTemplate}
        {
            openModal.open &&
            <Modal
                open={openModal.open}
                title={t(openModal.modalHead)}
                onClose={() => {
                    setOpenModal({ open: false, modalHead: "" })
                    setShowInfoBanner(false)
                    setSelectTemplateOpt('')
                }}
                primaryAction={{
                    content: openModal.modalHead === 'Remove Template' ? openModal.modalHead : t("Apply New Template"),
                    destructive: openModal.modalHead === 'Remove Template' ? true : false,
                    disabled: openModal.modalHead !== 'Remove Template' && showInfoBanner === false ? true : false,
                    onAction: () => openModal.modalHead === "Remove Template" ? actionOnTemplate("delete") : openModal.modalHead === "Change Template" ? actionOnTemplate('change') : actionOnTemplate('save'),
                    loading: loading
                }}
            >
                <Modal.Section>
                    {
                        openModal.modalHead === "Remove Template" ?
                            <BlockStack gap="400">
                                <Banner tone='warning'>
                                    <Text as='span'>{t("If you remove this product from the template, the corresponding template will become inactive due to the absence of assigned products. To reactivate the template, you can assign new products to it.")}</Text>
                                </Banner>
                                <Text as='p'>{t("Do you want to remove the template?")}</Text>
                            </BlockStack>
                            :
                            <BlockStack gap="400">
                                {
                                    showInfoBanner == true ?
                                        <Banner tone='warning'>
                                            <Text as='span'>{t("Using a template from a different product category may have a negative impact on your listing. It is important to note that the template you are attempting to assign does not correspond to the same product category. Therefore, altering the template could potentially harm your listing")}</Text>
                                        </Banner>
                                        : ""
                                }
                                <Select
                                    label={t("Template")}
                                    options={selectOpt.options}
                                    onChange={(val: any) => handleSelectChange(val)}
                                    value={selectTemplateOpt}
                                    placeholder={t('Select Template')}
                                />
                                {
                                    showInfoBanner == false ?
                                        <Banner>
                                            <Text as='span'>{t("Currently, you can only link templates that were generated by manually filtering products. However, we are in the process of including all templates for linking.")}</Text>
                                        </Banner> : ""
                                }
                            </BlockStack>
                    }
                </Modal.Section>
            </Modal>
        }
    </React.Fragment>
}

export default DI(GetTemplate)